import React, { useState, useMemo, useRef, useEffect } from "react";
import { Trans } from "react-i18next";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
function useBaseModal() {

    const [modalOpen, setModalOpen] = useState(false)
    const toggle = () => setModalOpen(!modalOpen)


    const MainModal = useMemo(() => {
        return ({ title, action, HandleSubmit, children, size }) => (
            <Modal isOpen={modalOpen} toggle={toggle} size={size}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody style={{ overflowY: 'visible' }}>
                    {children}
                </ModalBody>
                {action &&
                    <ModalFooter>
                        <Button className="mr-0 mx-3" onClick={toggle}><Trans>Close</Trans></Button>
                        <Button color="primary" onClick={HandleSubmit}><Trans>{action}</Trans></Button>
                    </ModalFooter>
                }
            </Modal>
        )
    }, [modalOpen])
    return [setModalOpen, toggle, MainModal]
}

export default useBaseModal


export function useCustomModal() {

    const [modalOpen, setModalOpen] = useState(false);
    const toggle = () => setModalOpen(!modalOpen);

    const MainModal = useMemo(() => {
        return ({ title, body, footer, size }) => (
            <Modal isOpen={modalOpen} toggle={toggle} size={size}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                {body && <ModalBody style={{ overflowY: 'visible' }}>{body}</ModalBody>}
                {footer && <ModalFooter>{footer}</ModalFooter>}
            </Modal>
        );
    }, [modalOpen]);

    return [setModalOpen, toggle, MainModal];
}


export function useConfirmModal(autoToggle = true) {

    const [modalOpen, setModalOpen] = useState(false)
    const toggle = () => setModalOpen(!modalOpen)

    const [callback, setCallback] = useState(() => () => { }); // Initialize with an empty function
    const [_pending, _setPending] = useState(false);
    const pendingRef = useRef(_pending);
    pendingRef.current = _pending;

    useEffect(() => {
        if (modalOpen) {
          _setPending(false);
        }
      }, [modalOpen]);

    const MainModal = useMemo(() => {
        return ({ title, action, children, pending, color = 'primary' }) => modalOpen && (
            <Modal isOpen={modalOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody style={{ overflowY: 'visible' }}>
                    {children}
                </ModalBody>
                {action &&
                    <ModalFooter>
                        <Button className="mr-0 mx-3" onClick={toggle} disabled={pending || pendingRef.current}><Trans>Close</Trans></Button>
                        <Button color={color} disabled={pending || pendingRef.current} onClick={(props) => { autoToggle && toggle();_setPending(true) ; callback(); }}>{pending || pendingRef.current ? <><span className="fa fa-spinner fa-spin" /> <Trans>Confirming</Trans></> : action}</Button>
                    </ModalFooter>
                }
            </Modal>
        )
    }, [modalOpen])

    return [setModalOpen, toggle, MainModal, setCallback]
}


export function useMakePaymentModal(autoToggle = true) {

    const [modalOpen, setModalOpen] = useState(false)
    const toggle = () => setModalOpen(!modalOpen)

    const MainModal = useMemo(() => {
        return ({ title, action, children, pending, callback }) => modalOpen && (
            <Modal isOpen={modalOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody style={{ overflowY: 'visible' }}>
                    {children}
                </ModalBody>
                {action &&
                    <ModalFooter>
                        <Button className="mr-0 mx-3" onClick={toggle}><Trans>Close</Trans></Button>
                        <Button color="primary" disabled={pending} onClick={(props) => { autoToggle && toggle(); callback(); }}>{pending ? <><span className="fa fa-spinner fa-spin" /> <Trans>Confirming</Trans></> : action}</Button>
                    </ModalFooter>
                }
            </Modal>
        )
    }, [modalOpen])

    return [setModalOpen, toggle, MainModal]
}

